document.addEventListener('DOMContentLoaded', () => {
    const formsCustom = document.querySelectorAll('.js-form');
    const backToForm = document.querySelectorAll('.js-back-to-form');

    if (formsCustom) {
        formsCustom.forEach(form => {
            //remove info error after change tekst
            let allInput = form.querySelectorAll('input');

            if(allInput){
                allInput.forEach(input=>{
                    input.addEventListener('input',(e) =>{
                        let parent = e.target.parentElement;
                        if(parent){
                            let errMessage = parent.querySelector('.js-error-form');
                            if(parent.classList.contains('is-error')){
                               parent.classList.remove('is-error');
                               if(errMessage){
                                errMessage.classList.remove('is-active');
                                errMessage.textContent = '';
                               }
                          }
                        }
                        
                    });
                });
            }

            form.addEventListener('submit', (e) => {
                e.preventDefault();
                const formAction = e.currentTarget.getAttribute('data-action');

                //add status
                form.parentElement.classList.add('js-processing');

                const data = new FormData(e.currentTarget);
                const erorrs = form.querySelectorAll('.js-error-form');
                erorrs.forEach(el => {
                    el.classList.remove('is-active');
                    el.parentElement.classList.remove('is-error');
                });

                const nonce = form.querySelector('.js-nonce-wrapper input');

                data.append('action', formAction);
                if (nonce) data.append('nonce', nonce.value);

                fetch(settings.ajaxurl, {
                        method: 'post',
                        body: data,
                    })
                    .then(response => response.json())
                    .then(response => {
                        form.parentElement.classList.remove('js-processing');

                        if (response.novalid) {
                            for (var obj_data of Object.keys(response.novalid)) {
                                console.log(obj_data);
                                erorrs.forEach(el => {
                                    if (el.classList.contains(obj_data)) {
                                        el.classList.add('is-active');
                                        el.parentElement.classList.add('is-error');
                                        el.textContent = response.novalid[obj_data]
                                    }
                                });
                            }
                        } else {
                            if (response.error_user) {
                                console.log(response.error_user);
                            } else {
                                console.log('user is register/loged/send reset!!');
                                const redirectUrl = form.getAttribute('data-redirect');
                                if (redirectUrl) window.location.href = redirectUrl;
                                form.parentElement.classList.add('js-succes');
                            }
                        }

                    })
                    .catch(err => {
                        console.log(err);
                        // alert("sorry, there are no results for your search")
                    });
            });
        });
    }

    if (backToForm) {
        backToForm.forEach(btn => {
            btn.addEventListener('click', (e) => {
                formsCustom.forEach(form => form.parentElement.classList.remove('js-succes'));
            });
        });
    }

});